var download = require('downloadjs');

import moment from 'moment';
import * as apiHelper from '../../apiHelper';
import * as constants from "./constants";
import * as global_constants from '../global/constants';

import { setUserLoggedOut, pushError, popError, navigateTo, setUserData, pushSuccess } from '../global/actions'

export function getBookings() {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiGet('bookings', state.Global.token)
      .then(response => response.json())
      .then(json => {
        if (json.error)
          return;

        if (json.auth === false) {
          dispatch(setUserLoggedOut());
        } else {
          dispatch(setAdminBookingsList(json.bookings));
        }
      })
  }
}

export function getListings() {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiGet('listing', state.Global.token)
      .then(response => response.json())
      .then(json => {
        if (json.error)
          return;

        if (json.auth === false) {
          dispatch(setUserLoggedOut());
        } else {
          dispatch(setAdminListingsList(json.listings));
        }
      })
  }
}

export function getUsers() {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiGet('users', state.Global.token)
      .then(response => response.json())
      .then(json => {
        if (json.error)
          return;

        if (json.auth === false) {
          dispatch(setUserLoggedOut());
        } else {
          dispatch(setAdminUsersList(json.users));
        }
      })
  }
}

export function featureListing(id, feature) {
  return (dispatch, getState) => {
    let state = getState()
    return apiHelper.apiPut('listing', { isFeatured: feature }, state.Global.token, id)
      .then(() => dispatch(getListings()));
  }
}
export function updateServiceFee(serviceFee, id) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPut('users', { serviceFees: serviceFee, _id: id }, state.Global.token, id)
      .then(() => dispatch(getUsers()));
  }
}

export function publishListing(id, publish) {
  return (dispatch, getState) => {
    let state = getState();
    return apiHelper.apiPut('listing', { isActive: publish }, state.Global.token, id)
      .then(() => dispatch(getListings()));
  }
}

export function enableUser(value, userId) {
  return (dispatch, getState) => {
    let state = getState();
    let user = state.User;
    user.isActive = value
  }
}

export function impersonateUser(password, userIdToImpersonate) {
  return (dispatch, getState) => {
    dispatch(popError('IMPERSONATION'));
    let state = getState();
    return apiHelper.apiPost('impersonate', { password: password, userIdToImpersonate: userIdToImpersonate }, state.Global.token)
      .then(response => response.json())
      .then(json => {
        if (json.error) {
          dispatch(pushError({ errType: 'IMPERSONATION', message: json.error }));
        } else if (json.auth === false) {
          dispatch(setUserLoggedOut());
        } else {
          dispatch({ type: global_constants.IMPERSONATE });
          dispatch({
            type: global_constants.LOGIN,
            data: { userId: json.user._id, token: json.token, impersonating: true }
          });
          dispatch(setUserData(json.user));
          dispatch(navigateTo('/dashboard'))
        }
      })
  }
}

export function setAdminBookingsList(bookings) {
  return {
    type: constants.SET_ADMIN_BOOKINGS_LIST,
    data: bookings
  }
}
export function setAdminListingsList(listings) {
  return {
    type: constants.SET_ADMIN_LISTINGS_LIST,
    data: listings
  }
}
export function setAdminUsersList(users) {
  return {
    type: constants.SET_ADMIN_USERS_LIST,
    data: users
  }
}

export function generateReferralReport(cb) {
  return (dispatch, getState) => {
    let state = getState();
    dispatch(popError('refrerror'));
    return apiHelper.apiPost('reports', {}, state.Global.token, 'referral')
      .then(response => {
        if (response.status === 200) {
          return response.blob();
        } else {
          dispatch(pushError({ errType: 'refrerror', message: 'A server error occurred. The report could not be generated.' }))
          cb();
          return null;
        }
      })
      .then(body => {
        if (body) { download(body, `Admin Referral Report (${moment().format("M/D/Y")}).csv`, "application/octet-stream"); }
        cb();
      });
  }
}

export function addStreamlineAccount(values) {
  return (dispatch, getState) => {
    const state = getState();
    return apiHelper.apiPost('admin', values, state.Global.token, 'addAdvertiser')
      .then(response => {
        if (response.status === 200) {
          dispatch(pushSuccess('Streamline account added.'));
        } else {
          dispatch(pushError('Error in adding this account.'))

        }
      }).catch(error => {
        console.error(error);
        dispatch(pushError('Some error occured.'))
      })
  }
}
